import React from 'react';
import {useNavigate} from 'react-router-dom';

import AppAnimateGroup from '../../../@crema/core/AppAnimateGroup';
import {Button} from 'antd';
import '../index.style.less';
import AppPageMetadata from '../../../@crema/core/AppPageMetadata';
import {ReactComponent as Logo} from '../../../assets/icon/404.svg';
import {useTranslation} from 'react-i18next';

const Error404 = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const onGoBackToHome = () => {
    navigate(-1);
  };

  return (
    <AppAnimateGroup type='bottom'>
      <AppPageMetadata title='Not Found' />
      <div className='error-container' key='a'>
        <div className='error-img'>
          <Logo />
        </div>
        <div className='error-content'>
          <h3>{t('int-404-error')}</h3>
          <div className='error-para'>
            <p className='mb-0'>{t('int-error-message')}</p>
          </div>
          <Button type='primary' className='error-btn' onClick={onGoBackToHome}>
            {t('int-error-go-back-to-home')}
          </Button>
        </div>
      </div>
    </AppAnimateGroup>
  );
};

export default Error404;
